<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>审核</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form style="margin-top: 2.5rem" label-width="140px">
			<el-form-item label="商户">
				{{distributorName}}
			</el-form-item>
			<el-form-item label="充值金额">
				{{amount}}元
			</el-form-item>
			<el-form-item label="凭证">
				<img :src="enclosure" />
			</el-form-item>
			<el-form-item label="备注">
				{{note}}
			</el-form-item>
		</el-form>
		<div slot="footer" style="align-items: center;" class="dialog-footer">
		  <el-button size="small" type="primary" @click="authPass()">通过</el-button>
		  <el-button size="small" type="danger" class="title" @click="authReject()">驳回</el-button>
		</div>
	</div>
</template>

<script>
	import {searchDetailApi,authPassApi,authRejectApi} from "../../api/recharge/rechargeApi.js"
	export default {
		data(){
			return {
				orderId: this.$route.params.id,
				distributorName:'',
				amount:'',
				enclosure:'',
				note:''
			}
		},
		methods:{
			authPass(){
				authPassApi(this.orderId).then(res=>{
					console.log(res.data.code)
					//if(res.data.code == '000000'){
						this.$router.push("/recharge/rechargelist")
					//}
				})
			},
			authReject(){
				authRejectApi(this.orderId).then(res=>{
					console.log(res.data.code)
					//if(res.data.code == '000000'){
						this.$router.push("/recharge/rechargelist")
					//}
				})
			}
		},
		created() {
			searchDetailApi(this.orderId).then(res =>{
				console.log(res)
				if(res.data.code == '000000'){
					this.distributorName = res.data.data.distributorName
					this.amount = res.data.data.amount
					this.enclosure = res.data.data.enclosure
					this.note = res.data.data.note
				}
			})
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/recharge/rechargeDetail.vue